import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import { LinearProgress } from '@mui/material'
import { H3 } from '../../../layouts/TextStyles'
import { useAppSelector } from '../../../app/hooks'
import { sectionApiSlice } from '../../../features/section/sectionSlice'
import Breadcrumb from '../../../components/Breadcrumb'
import GroupsTable from './components/GroupsTable'
import MonthWeekFilter from '../../../components/monthWeekFilter/MonthWeekFilter'

const GroupListPage = () => {
    const { formatMessage } = useIntl()
    const { id } = useAppSelector((state) => state.user.userInfo)
    const [monthNumber, setMonthNumber] = useState<number | undefined>()
    const [weekNumber, setWeekNumber] = useState<number | undefined>()
    const { data: groups = [], isFetching } =
        sectionApiSlice.useGetGroupsSectionAnalysisQuery({
            curatorId: id,
            monthNumber,
            weekNumber,
        })

    // Проценты считаются по темам выбранного периода
    const handlePeriodChange = (month?: number, week?: number) => {
        setMonthNumber(month)
        setWeekNumber(week)
    }

    return (
        <Wrapper>
            <Breadcrumb links={[formatMessage({ id: 'groups' })]} />

            <Content>
                <Header>
                    <Title>
                        <H3>{formatMessage({ id: 'groups' })}</H3>
                    </Title>

                    <MonthWeekFilter
                        monthNumber={monthNumber}
                        weekNumber={weekNumber}
                        onChange={handlePeriodChange}
                    />
                </Header>

                {isFetching && <LinearProgress />}

                <GroupsTable
                    groups={groups}
                    isFetching={isFetching}
                />
            </Content>
        </Wrapper>
    )
}

export default GroupListPage

const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`
const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
    color: #17141A;
`

const Content = styled.div`
    background-color: #fff;
    border: 1px solid #F0E8EE;
    border-radius: 16px;
    padding: 24px;
    min-height: 80vh;
`

const Header = styled.header`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
    align-items: center;
    justify-content: space-between;
`
